import tw from 'twin.macro';
import styled from 'styled-components';
import { BubbleMenu, FloatingMenu } from '@tiptap/react';

export const StyledFloatingMenu = styled(FloatingMenu)`
  display: flex;
  background-color: #0d0d0d10;
  padding: 0.2rem;
  border-radius: 0.5rem;

  button {
    border: none;
    background: none;
    font-size: 0.85rem;
    font-weight: 500;
    padding: 0 0.2rem;
    opacity: 0.6;

    &:hover,
    &.is-active {
      opacity: 1;
    }
  }
`;

export const StyledBubbleMenu = styled(BubbleMenu)`
  display: flex;
  padding: 0.2rem;
  border-radius: 5px;
  ${tw`bg-slate-800`}

  button {
    border: none;
    background: none;
    color: #fff;
    font-size: 1rem;
    font-weight: 500;
    padding: 0.25rem 0.5rem;
    opacity: 0.6;
    border-radius: 5px;

    &:hover,
    &.is-active {
      ${tw`bg-slate-600`}
      opacity: 1;
    }
  }
`;

export const StyledProseMirrorWrapper = styled.div`
  .ProseMirror {
    min-height: 100px;
  }

  .ProseMirror table,
  .ProseMirror table[style*='width:0'],
  .ProseMirror table[style*='width: 0'] {
    width: auto !important;
    min-width: 200px !important;
  }

  .ProseMirror p {
    white-space: collapse !important;
  }

  .ProseMirror p.is-editor-empty:first-child::before {
    content: attr(data-placeholder);
    float: left;
    pointer-events: none;
    height: 0;
    ${tw`text-slate-400`}
  }

  .ProseMirror-focused {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  .ProseMirror {
    > * + * {
      margin-top: 0.75em;
    }

    ul,
    ol {
      padding: 0 1rem;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      line-height: 1.1;
    }

    code {
      background-color: rgba(#616161, 0.1);
      color: #616161;
    }

    pre {
      background: #0d0d0d;
      color: #fff;
      font-family: 'JetBrainsMono', monospace;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;

      code {
        color: inherit;
        padding: 0;
        background: none;
        font-size: 0.8rem;
      }
    }

    img {
      max-width: 100%;
      height: auto;
    }

    blockquote {
      padding-left: 1rem;
      border-left: 2px solid rgba(#0d0d0d, 0.1);
    }

    hr {
      border: none;
      border-top: 2px solid rgba(#0d0d0d, 0.1);
      margin: 2rem 0;
    }
  }
`;
